import * as types from "./responderExigencia.actionTypes";

export default {
  setTokenRecaptcha: data => ({
    type: types.SET_TOKEN_RECAPTCHA,
    payload: data
  }),
  setHeaderExigencia: data => ({
    type: types.SET_HEADER_EXIGENCIA,
    payload: data
  }),
  validaAnaliseExigencia: data => ({
    type: types.VALIDA_ANALISE_EXIGENCIA,
    payload: data
  }),
  toggleDocumentoModal: () => ({
    type: types.TOGGLE_MODAL_DOCUMENTO
  }),
  toggleExigenciaModal: () => ({
    type: types.TOGGLE_MODAL_EXIGENCIA
  }),
  setShowGridExigencia: showGrid => ({
    type: types.SET_SHOW_GRID_EXIGENCIA,
    payload: showGrid
  }),
  setDataGridExigencia: data => ({
    type: types.SET_DATA_GRID_EXIGENCIA,
    payload: data,
  }),
  setFormExigencia: data => ({
    type: types.SET_FORM_EXIGENCIA,
    payload: data,
  }),
  validaUploadDocumentoExigencia: data => ({
    type: types.VALIDA_UPLOAD_DOCUMENTO_EXIGENCIA,
    payload: data
  }),
  removerDocumentoExigencia: data => ({
    type: types.REMOVER_DOCUMENTO_EXIGENCIA,
    payload: data
  }),
  postRespostaExigencia: data => ({
    type: types.POST_RESPOSTA_EXIGENCIA,
    payload: data
  }),
  resetForm: () => ({
    type: types.RESET_FORM,
  }),
  setModalExigencia: data => ({
    type: types.SET_MODAL_EXIGENCIA,
    payload: data,
  }),
};
